'use client'
import {Navbar} from "react-bootstrap";
import Link from "next/link";
import Image from "next/image";

interface ILogo {
}

export const Logo: React.FC<ILogo> = (): JSX.Element => {
    return (
        <Navbar.Brand>
            <Link href="/">
                <Image
                    src="/images/logo.svg"
                    alt="Logo"
                    width={90}
                    height={52}
                    priority
                />
            </Link>
        </Navbar.Brand>
    );
};
